import { resolveOnlineOrderTags } from './online-order-tags';
import OnlineOrderTagBadge from './online-order-tag-badge';

interface Props {
  tags: readonly string[];
  size?: 'sm' | 'md';
}

// Read-only list of the tags currently applied to an order. Renders nothing
// when the order has no (known) tags.
function OnlineOrderTagList(props: Props) {
  const tags = resolveOnlineOrderTags(props.tags);
  if (tags.length === 0) {
    return null;
  }

  return (
    <div className="flex flex-wrap gap-1">
      {tags.map((tag) => (
        <OnlineOrderTagBadge key={tag.key} tag={tag} size={props.size} />
      ))}
    </div>
  );
}

export default OnlineOrderTagList;
